/**
 * Переключает состояние формы между режимами «Авторизация» и «Регистрация».
 * Сбрасывает пароли, очищает сообщения об ошибках и перестраивает DOM-элементы
 * (видимость полей, тексты кнопок, ссылки в футере) в зависимости от выбранной вкладки.
 *
 * @module
 */


import {removeElements} from "./auth-misc-functions.js";
import {hideElement, showElement} from "../visibility/showHide.js";
import {agreementActivate} from "../agreements/agreement.js";
import {authAccountElements, authElements} from "./auth-account-elements.js";


/**
 * При загрузке модуля сразу устанавливает слушатель на поле ввода email формы авторизации.
 * При вводе автоматически переводит текст в нижний регистр и
 * дублирует его во все поля регистрации (класс .email_register).
 */

if (authElements.ttAuthEmail) {
    authElements.ttAuthEmail.addEventListener('input', function() {
        const val = this.value.toLowerCase();
        const registerEmails = document.querySelectorAll('.email_register');
        registerEmails.forEach(element => {
            element.value = val;
        });
    });
}

/**
 * Вспомогательная функция.
 * Показывает интерфейс для вкладки "войти"
 *
 * @returns {void}
 */
function showTabEnter() {
    // класс email_register нужен только для вкладки регистрации, убираем
    if (authElements.ttAuthEmail) authElements.ttAuthEmail.classList.remove('email_register');

    // очищаем поля паролей
    if (authAccountElements.ttAuthPassword) {
        authAccountElements.ttAuthPassword.value = '';
        showElement(authAccountElements.ttAuthPassword);
    }
    if (authAccountElements.ttAuthPasswordNew) authAccountElements.ttAuthPasswordNew.value = '';

    // скрываем поля аватара, капчи и никнейма
    hideElement(authElements.ttAuthAvaDiv);
    hideElement(authElements.ttAuthCapDiv);
    hideElement(authElements.ttAuthName);

    // на поле auth-registration вешаем доп. класс enter и удаляем доп. класс registration
    if (authElements.authRegistration) {
        authElements.authRegistration.classList.remove('registration');
        authElements.authRegistration.classList.add('enter');
    }

    // с таба "зарегистрироваться" снимаем класс active, а на таб войти его вешаем
    if (authElements.ttAuthTabRegistration) authElements.ttAuthTabRegistration.classList.remove('active');
    if (authElements.ttAuthTabEnter) authElements.ttAuthTabEnter.classList.add('active');

    // на кнопке внизу будет надпись "Войти на сайт"
    if (authElements.ttAuthBtn) authElements.ttAuthBtn.value = 'Войти на сайт';

    hideElement(authAccountElements.ttAuthPasswordNew); // поле повторения нового пароля скрываем
    showElement(authElements.FLRemindme);  // показываем ссылку "вспомнить пароль"
    //hideElement(accountElementsObject.FLPrivacy);
    hideElement(authElements.digest); // скрыли блок подписаться на дайджест
    showElement(authElements.ttAuthEmail);
}


/**
 * Вспомогательная функция.
 * Показывает интерфейс для вкладки "регистрация"
 *
 * @returns {void}
 */

function showTabRegistration() {
    // если в поле емейла было что-то - приводим это в нижний регистр и вешаем класс, показывающий, что это регистрация
    if (authElements.ttAuthEmail) {
        authElements.ttAuthEmail.value = authElements.ttAuthEmail.value.toLowerCase();
        authElements.ttAuthEmail.classList.add('email_register');
    }

    // очищаем поля паролей и показываем поле повтора нового пароля
    if (authAccountElements.ttAuthPassword) {
        authAccountElements.ttAuthPassword.value = '';
        showElement(authAccountElements.ttAuthPassword);
    }
    if (authAccountElements.ttAuthPasswordNew) {
        authAccountElements.ttAuthPasswordNew.value = '';
        showElement(authAccountElements.ttAuthPasswordNew);
    }

    // на поле auth-registration вешаем доп. класс registration и удаляем доп. класс enter
    if (authElements.authRegistration) {
        authElements.authRegistration.classList.remove('enter');
        authElements.authRegistration.classList.add('registration');
    }

    // делаем активной вкладку регистрации
    if (authElements.ttAuthTabEnter) authElements.ttAuthTabEnter.classList.remove('active');
    if (authElements.ttAuthTabRegistration) authElements.ttAuthTabRegistration.classList.add('active');

    // на кнопке будет надпись "Зарегистрироваться", а не "Войти"
    if (authElements.ttAuthBtn) authElements.ttAuthBtn.value = 'Зарегистрироваться';

    hideElement(authElements.FLRemindme); // убираем ссылку "вспомнить пароль"
    showElement(authElements.digest); // показываем блок подписки на дайджест
    hideElement(authElements.ttAuthName);
}

/**
 *
 * @param {Event} [e] - объект события
 * @param {'enter'|'registration'} t - флаг, на какую вкладку хотим перейти
 * @returns {Promise<void>} - ответ никак не обрабатываем потом
 */
const ttAuth_tab_click = async (e, t) => {
    e?.preventDefault();

    const authT = document.getElementById('ttAuth_tab_' + t); //ttAuth_tab_enter или ttAuth_tab_registration
    if (authElements.ttAuthHiddenField) authElements.ttAuthHiddenField.value = 'auth'; // мы на странице авторизации

    removeElements('.g-message');

    // Если мы во вкладке enter (хотим переключиться на вход и мы еще не там)
    if (t === 'enter' && !(authT?.classList.contains('active'))) {
        showTabEnter();
        await agreementActivate(false); // нам не нужно соглашение, false скроет блок, если он был

    }
    // Если мы во вкладке registration (хотим переключиться на регистрацию и мы еще не там)
    else if (t === 'registration' && !(authT?.classList.contains('active'))) {
        showTabRegistration();
        await agreementActivate(true); // нам нужен блок соглашения
    }
}

export default ttAuth_tab_click;